<template>
    <div>
        <fade-transition origin="center" mode="out-in" :duration="250">
            <div class="prompt_pop_wrap" v-if="show">
                <div class="prompt_pop_box">
                    <div class="prompt_pop_content">
                        <p>
                            {{ title }}
                        </p>
                    </div>
                    <div class="btn-wrapper" v-if="type == 'alert'" @click.stop="alertClick">
                        <span class="btn btn-block yes-btn">{{alertBtnText}}</span>
                    </div>
                    <div class="btn-wrapper" v-if="type == 'confirm'">
                        <div class="prompt_pop_btns">
                            <div class="prompt_pop_btn" @click="noClick">
                                {{noBtnText}}
                            </div>
                            <div class="prompt_pop_btn" @click="yesClick">
                                {{yesBtnText}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </fade-transition>
    </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
export default {
    name: 'Modal',
    components: {
        FadeTransition,
    },
    props: {
        title: {
            type: String,
            default: '提示'
        },
        msg: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'alert'
        },
        alertBtnText: {
            type: String,
            default: '我知道了'
        },
        yesBtnText: {
            type: String,
            default: '确定'
        },
        noBtnText: {
            type: String,
            default: '取消'
        },
        hasMark: {
            type: Boolean,
            default: true
        }

    },
    data() {
        return {
            promiseStatus: null,
            show: false
        }
    },
    methods: {
        confirm() {
            let _this = this;
            this.show = true;
            return new Promise(function(resolve, reject) {
                _this.promiseStatus = { resolve, reject };
            });
        },
        noClick() {
            this.show = false;
            this.promiseStatus && this.promiseStatus.reject();

        },
        yesClick() {
            this.show = false;
            this.promiseStatus && this.promiseStatus.resolve();

        },
        alertClick() {
            this.show = false;
            this.promiseStatus && this.promiseStatus.resolve();
        }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.prompt_pop_wrap {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .34);
    z-index: 9999;

    .prompt_pop_box {
        width: 246px;
        background: #ffffff;
        border-radius: 4px;

        .prompt_pop_content {
            padding: 21px 15px 19px;
            line-height: 23px;
            font-size: 15px;
            color: #333333;
            text-align: center;

            >p {
                min-height: 46px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .prompt_pop_btns {
            border-top: #D8D8D8 solid 1px;
            height: 42px;
            display: flex;

            .prompt_pop_btn {
                flex: 1;
                text-align: center;
                line-height: 42px;
                color: #fe484a;
                font-size: 14px;
            }

            .prompt_pop_btn:nth-child(1) {
                border-right: #D8D8D8 solid 1px;
                color: #939393;
            }

            .prompt_pop_btn:only-child {
                color: #1D88D0;
            }
        }
    }
}
</style>